import { useState } from "react";
import { Paper, Grid,  } from "@mui/material";
import { useSnackbar } from "notistack";
import { globalGetService } from "../../../utils/globalApiServices";
import { getEngineTechSpecsReportApi } from "../apiService";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import Header from "./Header";
import LessorFilter from "./LessorFilter";
import { trackActivity } from "../../../utils/mixpanel";

const EngineTechSpecsReport = ({pltConstants,dropDownLoader}) => {
   const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [reportData, setReportData] = useState({});
    const onFieldChange = (key, value) => { setReportData({ ...reportData, [key]: value }) }
    const onExportReport = (extention,lessorId) => {
      const query = {
        file_type: extention, 
        ...(reportData?.lessor_name_id?.length > 0) && { lessor_name_id: reportData?.lessor_name_id?.map(item => item.id).join(",") ?? "" },
      };
      setLoading(true)
      globalGetService(getEngineTechSpecsReportApi(query))
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Engine Technical Specifications Report`, success_msg: response?.data?.message, payload: query, response: response?.data })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Engine Technical Specifications Report`, error_msg: response?.data?.message, payload: query, response: response?.data })
          }
        });
    };

  return (
    <Paper square>
      <div className='custom-rpt-card'>
      <div className='rpt-card-header'>
          <Grid container spacing={{ xs: 5, md: 1 }} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 8}}>
              <Header title="Engine Technical Specifications Report" description="High-Level Summary of ESN's; Includes some Maintenance Spend Data. Contains No Invoicing Data." />
            </Grid>
            <Grid size={{ md: 2, xs: 4}} sx={{ display: "flex", justifyContent: "flex-end",alignItems: "flex-start"  }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }, { title: 'CSV', extension: 'csv' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
        <Grid size={{ md: 12, xs: 12 }}>
        <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange}/>
        </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default EngineTechSpecsReport